import React, {useState} from 'react';
import {connect} from "react-redux";
import {Card, CardBody, CardTitle, Col, Collapse, Row} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import SelectGeneric from "../../../components/select/selectGeneric";
import {menuOptionsProvider} from "../../../providers/menuOptionsProvider";
import {DragDropList} from "../../../components/draggableList/DragDropList";
import {TT_EDIT, TT_REMOVE} from "../../../components/i18n/toolTips";
import {
    mockModuleMenuResponse,
    mockTableAdapterRows,
    mockTableAdapterBasicColumns,
    buildMockTableAdapterColumns,
    mockTableAdapterExpandableRows,
    mockTableAdapterPagedRows,
} from "./mockups";
import {GenericContainer} from "../../../components/containers/GenericContainer";
import TableAdapter from "../../../components/TableAdapter/TableAdapter";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";

function ComponentCatalog(props) {

   const [menuId, setMenuId] = useState(null);
    const [showSelect, setShowSelect] = useState(false);

    // ----------------------------------------------
    //   TableAdapter demo state (remote pagination mock)
    // ----------------------------------------------
    const [tablePageIndex, setTablePageIndex] = useState(0);
    const [tablePageSize, setTablePageSize] = useState(10);
    const [hideAppNameColumn, setHideAppNameColumn] = useState(false);

    // Local state copies for demos that allow modifying rows (remove)
    const [demoRows, setDemoRows] = useState(mockTableAdapterRows);
    const [demoActionRows, setDemoActionRows] = useState(mockTableAdapterRows);

    const pagedRowsSlice = mockTableAdapterPagedRows.slice(
        tablePageIndex,
        tablePageIndex + tablePageSize
    );

    const handleTableAdapterPageChange = (type, {page, sizePerPage}) => {
        const currentIndex = (page - 1) * sizePerPage;
        setTablePageIndex(currentIndex);
        setTablePageSize(sizePerPage);
    };

    const removeDemoRow = (id) => {
        setDemoRows(prev => prev.filter(r => r.id !== id));
        setDemoActionRows(prev => prev.filter(r => r.id !== id));
    };

    const tableActionsFormatter = (cell, row) => (
        <>
            <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => notImplementedAction('EditItem: ' + row.code)}/>
            <GenericTableButton toolTip={TT_REMOVE} icon={'fa-trash'} permission={'delete'} onClick={() => removeDemoRow(row.id)}/>
        </>
    );

    const expandRowRenderer = (row) => (
        <ul className="mb-0">
            {row.langs.map(l => (
                <li key={l.lang}><b>{l.lang}:</b> {l.value}</li>
            ))}
        </ul>
    );

    const notImplementedAction = (action) => {
        console.log('sin implementar:', action);
    }

    const renderContent = (_option, index) => {
        return (
            <div className={'module-menu-item'}>
                <label className="module-menu-item-title">
                    <h3><i className={"fas " + _option.icon + " mr-4"}/></h3>
                    <h3>{_option.name}</h3>
                </label>
                <div className="float-right">
                    <GenericButton
                        style={'table'}
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={_ => notImplementedAction('EditItem')}/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => notImplementedAction('RemoveItem')}
                    />
                </div>
            </div>
        )
    }

    return (
        <div>
            <Card>
                <div>
                    <h1>GenericButton</h1>
                </div>
                <div>
                    <Row>
                        <Col md={4}>
                            <GenericButton
                                style={'primary'}
                                label={'Primario'}
                                toolTip={'Primario sin icono'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'primary'}
                                icon={'fa-trash'}
                                label={'Primario'}
                                toolTip={'Primario con icono'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'primary'}
                                icon={'fa-trash'}
                                toolTip={'Primario con icono y sin label'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                        </Col>
                        <Col md={4}>
                            <GenericButton
                                style={'secondary'}
                                label={'Secundario'}
                                toolTip={'Secundario sin icono'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'secondary'}
                                icon={'fa-trash'}
                                label={'Secundario'}
                                toolTip={'Secundario con icono'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'secondary'}
                                icon={'fa-trash'}
                                toolTip={'Secundario con icono y sin label'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                        </Col>
                        <Col md={4}>
                            <GenericButton
                                style={'table'}
                                label={'Tabla'}
                                toolTip={'Tabla sin icono'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'table'}
                                icon={'fa-trash'}
                                label={'Tabla'}
                                toolTip={'Tabla con icono'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'table'}
                                icon={'fa-trash'}
                                toolTip={'Tabla con icono y sin label'}
                                permission={'add'}
                                onClick={notImplementedAction}
                            />
                        </Col>
                        <Col md={4}>
                            <GenericButton
                                style={'danger'}
                                label={'Danger'}
                                toolTip={'Danger sin icono'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'danger'}
                                label={'Danger'}
                                icon={'fa-times'}
                                toolTip={'Danger con icono'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'danger'}
                                icon={'fa-times'}
                                toolTip={'Danger con icono y sin label'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                        </Col>
                        <Col md={4}>
                            <GenericButton
                                style={'success-secondary'}
                                label={'Success'}
                                toolTip={'Success sin icono'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'success-secondary'}
                                label={'Success'}
                                icon={'fa-plus'}
                                toolTip={'Success con icono'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'success-secondary'}
                                icon={'fa-plus'}
                                toolTip={'Success con icono y sin label'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                        </Col>
                        <Col md={4}>
                            <GenericButton
                                style={'danger-secondary'}
                                label={'Danger'}
                                toolTip={'Danger sin icono'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'danger-secondary'}
                                label={'Danger'}
                                icon={'fa-times'}
                                toolTip={'Danger con icono'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                            <GenericButton
                                style={'danger-secondary'}
                                icon={'fa-times'}
                                toolTip={'Danger con icono y sin label'}
                                permission={'search'}
                                onClick={notImplementedAction}
                            />
                        </Col>
                    </Row>
                </div>
            </Card>


            <Card>
                <div>
                    <h1>GenericSortableContainer</h1>
                </div>
                <Row>
                    <Col md={6}>
                        <GenericContainer
                            titlle={'Crear + Agregar + Ordenar'}
                            listItems={mockModuleMenuResponse}
                            renderContent={renderContent}

                            provider={menuOptionsProvider}
                            option={menuId}
                            setOption={setMenuId}
                            onAddItem={notImplementedAction}

                            onCreateItem={notImplementedAction}
                            onReorderItems={notImplementedAction}
                        />
                    </Col>
                    <Col md={6}>
                        <GenericContainer
                            titlle={'Crear + Ordenar'}
                            listItems={mockModuleMenuResponse}
                            renderContent={renderContent}

                            onCreateItem={notImplementedAction}
                            onReorderItems={notImplementedAction}
                        />
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col md={6}>
                        <GenericContainer
                            titlle={'Agregar + Ordenar'}
                            listItems={mockModuleMenuResponse}
                            renderContent={renderContent}

                            provider={menuOptionsProvider}
                            option={menuId}
                            setOption={setMenuId}
                            onAddItem={notImplementedAction}

                            onReorderItems={notImplementedAction}
                        />
                    </Col>
                    <Col md={6}>
                        <GenericContainer
                            titlle={'Crear + NoOrdenar'}
                            listItems={mockModuleMenuResponse}
                            renderContent={renderContent}

                            onCreateItem={notImplementedAction}
                        />
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col md={6}>
                        <GenericContainer
                            titlle={'Listado vacio'}
                            listItems={[]}
                            renderContent={renderContent}
                        />
                    </Col>
                    <Col md={6}>
                        <GenericContainer
                            titlle={'Ver + NoOrdenar'}
                            listItems={mockModuleMenuResponse}
                            renderContent={renderContent}
                        />
                    </Col>
                </Row>
            </Card>
            {/*<ImagePickerMigrateTool className={'place'} />*/}

            {/*<ImagePickerMigrateTool className={'hotelActivity'} />*/}

            {/*<ImagePickerMigrateTool className={'hotelCategory'} />*/}

            <Card>
                <div>
                    <h1>TableAdapter</h1>
                </div>

                <div className="mb-4">
                    <h5>Uso básico (data + columns, sin paginación ni expandRow)</h5>
                    <TableAdapter
                        striped hover
                        keyField="id"
                        data={mockTableAdapterRows}
                        columns={mockTableAdapterBasicColumns}
                        noDataIndication={'Sin datos'}
                    />
                </div>

                <div className="mb-4">
                    <h5>Columna isDummyField con formatter (acciones) + columna id oculta</h5>
                    <TableAdapter
                        striped hover
                        keyField="id"
                        data={demoActionRows}
                        columns={buildMockTableAdapterColumns({actionsFormatter: tableActionsFormatter})}
                        noDataIndication={'Sin datos'}
                    />
                </div>

                <div className="mb-4">
                    <h5>Columna hidden condicional (appName)</h5>
                    <GenericButton
                        style={'secondary'}
                        label={hideAppNameColumn ? 'Mostrar columna APP' : 'Ocultar columna APP'}
                        toolTip={'Alternar columna hidden'}
                        permission={'edit'}
                        onClick={() => setHideAppNameColumn(prev => !prev)}
                    />
                    <TableAdapter
                        striped hover
                        keyField="id"
                        data={demoRows}
                        columns={buildMockTableAdapterColumns({
                            hideAppName: hideAppNameColumn,
                            actionsFormatter: tableActionsFormatter,
                        })}
                        noDataIndication={'Sin datos'}
                    />
                </div>

                <div className="mb-4">
                    <h5>expandRow (showExpandColumn + expandByColumnOnly)</h5>
                    <TableAdapter
                        striped hover
                        keyField="id"
                        data={mockTableAdapterExpandableRows}
                        columns={mockTableAdapterBasicColumns}
                        expandRow={{
                            renderer: expandRowRenderer,
                            showExpandColumn: true,
                            expandByColumnOnly: true,
                        }}
                        noDataIndication={'Sin datos'}
                    />
                </div>

                <div className="mb-4">
                    <h5>Paginación remota (pageIndex/pageSize/totalSize simulados)</h5>
                    <TableAdapter
                        striped hover
                        remote
                        keyField="id"
                        data={pagedRowsSlice}
                        columns={mockTableAdapterBasicColumns}
                        pagination={{
                            pageIndex: tablePageIndex,
                            pageSize: tablePageSize,
                            totalSize: mockTableAdapterPagedRows.length,
                        }}
                        onTableChange={handleTableAdapterPageChange}
                        noDataIndication={'Sin datos'}
                    />
                </div>

                <div className="mb-4">
                    <h5>noDataIndication (data vacía)</h5>
                    <TableAdapter
                        striped hover
                        keyField="id"
                        data={[]}
                        columns={mockTableAdapterBasicColumns}
                        noDataIndication={'No se encontraron registros'}
                    />
                </div>
            </Card>
        </div>
    );
}

const mapStateToProps = state => ({});

const mapActionsToProps = ({});

export default connect(mapStateToProps, mapActionsToProps)(ComponentCatalog)